import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./Products.css";
import DashSideBar from "../../shared/DashSideBar";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import Resizer from "react-image-file-resizer";

function Products() {
  let emptyProduct = {
    id: null,
    name: "",
    breadCrumb: "",
    sortOrder: null,
    imageUrl: null,
    category: { id: null, name: "" },
    brand: { id: null, name: "" },
  };

  const [products, setProducts] = useState(null);
  const [categories, setCategories] = useState(null);
  const [brands, setBrands] = useState(null);
  const [productDialog, setProductDialog] = useState(false);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deletProductsDialog, setDeletProductsDialog] = useState(false);
  const [product, setProduct] = useState(emptyProduct);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [file, setFile] = useState(null);

  const isFetched = useRef(false);
  useEffect(() => {
    if (!isFetched.current) {
      getProducts();
      getCategories();
      getBrands();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/Products/ProductDashboardResponse"
      );

      if (response.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  const getCategories = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Categories"
      );

      if (response.data) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  const getBrands = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Brands"
      );

      if (response.data) {
        setBrands(response.data);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    }
  };
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1000, // width
        1000, // height
        "WEBP", // format (can be "JPEG", "PNG", "WEBP")
        100, // quality (0-100)
        0, // rotation (optional)
        (uri) => {
          resolve(uri);
        },
        "blob" // output type (blob or base64)
      );
    });

  const openNew = () => {
    setProduct(emptyProduct);
    setSubmitted(false);
    setProductDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProductDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeletProductsDialog(false);
  };

  const saveProduct = async () => {
    setLoading(true);
    setSubmitted(true);

    if (product.name.trim()) {
      let _products = [...products];
      let _product = { ...product };

      try {
        if (product.id) {
          const index = findIndexById(product.id);

          let formData = new FormData();
          formData.append("Name", _product.name);
          formData.append("BreadCrumb", _product.breadCrumb);
          formData.append(
            "SortOrder",
            isNaN(parseInt(_product.sortOrder))
              ? 1
              : parseInt(_product.sortOrder)
          );
          formData.append("CategoryId", _product.category.id);
          formData.append("BrandId", _product.brand.id);

          if (file != null) {
            formData.append("ImageUrl", file);
          }

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL + "api/Products/" + product.id,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (response.data.success) {
            _products[index] = _product;
            if (response.data.fileName !== "")
              _products[index].imageUrl = response.data.fileName;

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Image Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Image Not Updated",
              life: 3000,
            });
          }
        } else {
          _product.id = createId();

          let formData = new FormData();
          formData.append("Name", _product.name);
          formData.append("BreadCrumb", _product.breadCrumb);
          formData.append(
            "SortOrder",
            isNaN(parseInt(_product.sortOrder))
              ? 1
              : parseInt(_product.sortOrder)
          );
          formData.append("CategoryId", _product.category.id);
          formData.append("BrandId", _product.brand.id);
          formData.append("ImageUrl", file);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Products",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (response.data.success) {
            _products.push(response.data.product);

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Image Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Image Not Added",
              life: 3000,
            });
          }
        }

        setProducts(_products);
        setProductDialog(false);
        setProduct(emptyProduct);
      } catch (error) {
        console.error("Error while saving product:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "An unexpected error occurred while saving the product",
          life: 3000,
        });
      } finally {
        setLoading(false);
        setFile(null);
      }
    } else {
      setLoading(false);
    }
  };

  const editProduct = (product) => {
    setProduct({ ...product });
    setProductDialog(true);
  };

  const confirmDeleteProduct = (product) => {
    setProduct(product);
    setDeleteProductDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/Products/" + product.id
    );
    setLoading(false);
    if (response.data.success) {
      let _products = products.filter((val) => val.id !== product.id);
      setProducts(_products);
      setDeleteProductDialog(false);
      setProduct(emptyProduct);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Product Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < products.length; i++) {
      if (products[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.imageUrl}
        alt={rowData.imageUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeletProductsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProducts.map((product) => product.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Products/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _products = products.filter((val) => !selectedProducts.includes(val));
      console.log(_products);
      setProducts(_products);
      setDeletProductsDialog(false);
      setSelectedProducts(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "products Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "products Not Deleted",
        life: 3000,
      });
    }
  };

  const onCategoryChange = (selectedOption) => {
    const selectedCategoryId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedCategory = categories.find(
      (category) => category.id === selectedCategoryId
    );

    setProduct({
      ...product,
      category: { id: selectedOption.value, name: selectedCategory.name },
    });
  };
  const onBrandChange = (selectedOption) => {
    const selectedBrandId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedBrand = brands.find((brand) => brand.id === selectedBrandId);

    setProduct({
      ...product,
      brand: { id: selectedOption.value, name: selectedBrand.name },
    });
  };
  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    const resizedImage = await resizeFile(file); // Resize the image

    // Create a new File from the blob with the correct name and MIME type
    const newFile = new File([resizedImage], file.name, {
      type: resizedImage.type || "image/jpeg", // Set MIME type
    });
    setFile(newFile);

    setProduct((prevProduct) => ({
      ...prevProduct,
      imageUrl: process.env.REACT_APP_BACKEND_URL_IMAGES + newFile.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _product = { ...product };

    _product[`${name}`] = val;

    setProduct(_product);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Products</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedProducts || !selectedProducts.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Products</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveProduct}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="product-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={products}
              selection={selectedProducts}
              onSelectionChange={(e) => setSelectedProducts(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Products"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="imageUrl"
                header="Image"
                body={imageBodyTemplate}
              ></Column>
              <Column
                field="name"
                header="Name"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                field="sortOrder"
                sortable
                header="Order"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="category.name"
                header="Category"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="brand.name"
                header="Brand"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={productDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Product Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            {product.imageUrl && (
              <div className="image-container">
                <img
                  loading="lazy"
                  src={
                    process.env.REACT_APP_BACKEND_URL_IMAGES + product.imageUrl
                  }
                  alt={product.imageUrl}
                  className="product-image block m-auto pb-3"
                />
              </div>
            )}
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={product.name ?? ""}
                onChange={(e) => onInputChange(e, "name")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !product.name,
                })}
              />
              {submitted && !product.name && (
                <small className="p-error">Name is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="breadCrumb" className="font-bold mb-1">
                Breadcrumb :
              </label>
              <InputText
                id="breadCrumb"
                value={product.breadCrumb ?? ""}
                onChange={(e) => onInputChange(e, "breadCrumb")}
                required
                className={classNames({
                  "p-invalid": submitted && !product.breadCrumb,
                })}
              />
              {submitted && !product.breadCrumb && (
                <small className="p-error">Breadcrumb is required.</small>
              )}
            </div>

            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={product.sortOrder ?? 1}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !product.sortOrder,
                })}
              />
              {submitted && !product.sortOrder && (
                <small className="p-error">sortOrder is required.</small>
              )}
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Categories</label>
              {categories != null ? (
                <Dropdown
                  value={product.category.id}
                  options={categories.map((category) => ({
                    value: category.id,
                    label: category.name,
                  }))}
                  onChange={onCategoryChange}
                  placeholder="Select a Category"
                  appendTo="self"
                />
              ) : (
                <p>Loading categories...</p>
              )}
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Brands</label>
              {brands != null ? (
                <Dropdown
                  value={product.brand.id}
                  options={brands.map((brand) => ({
                    value: brand.id,
                    label: brand.name,
                  }))}
                  onChange={onBrandChange}
                  placeholder="Select a Brand"
                  appendTo="self"
                />
              ) : (
                <p>Loading brands...</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="image" className="mt-3 mb-1 font-bold">
                Image :
              </label>
              <FileUpload
                name="image"
                mode="basic"
                accept="image/*"
                onSelect={onFileUpload}
              />
            </div>
          </Dialog>

          <Dialog
            visible={deleteProductDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {product && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{product.name}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={deletProductsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {product && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected products?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default Products;
